//External Dependencies
import React, { Component } from "react";
//Internal Dependencies
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";
import { IntegratedSystemsProvider } from "./context/IntegratedSystemsContext";

//Component
class IntegratedSystems extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <IntegratedSystemsProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </IntegratedSystemsProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default IntegratedSystems;